import axios from "axios";
import { UploadSettings } from "client/types/HandleFile";
import { ImageUpload } from "store/features/imageUploader/types";
import { downloadImage } from "./downloadImage";
import { getImageUrl, getImageUrl as _getImageUrl } from "./getImageUrl";

export const downloadImageInFrontendTools = async (
    upload: ImageUpload["upload"],
    url: string,
    size: number,
    onDownloadProgress?: (progressEvent: number, downloadedSize: number) => void,
    headers?: any,
    ext?: string,
): Promise<{ src: string; error?: boolean }> => {
    return new Promise<{
        src: string;
        error?: boolean;
    }>(async (resolve, _reject) => {
        if (upload.type === "device" && ext !== "heic" && ext !== "heif") {
            resolve({
                src: url,
            });
        }

        const headerObj = headers ?? {};

        if (upload.type === "googleDrive") {
            headerObj["Authorization"] = `Bearer ${(upload.settings as UploadSettings["googleDrive"]).access_token}`;
        }
        const urlToDownload =
            upload.type === "googleDrive"
                ? (upload.settings as UploadSettings["googleDrive"]).fetch_url
                : upload.type === "url"
                ? (await checkCORS(url))
                    ? getImageUrl(url)
                    : url
                : url;

        downloadImage(urlToDownload, size, onDownloadProgress, headerObj, ext)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                resolve({
                    src: "",
                    error: true,
                });
            });
    });
};

export const checkCORS = async (url: string): Promise<boolean> => {
    try {
        await axios.head(url);
        return false;
    } catch (e) {
        return true;
    }
};
